import { helper } from '@ember/component/helper';

import { utcOffset } from 'rise-ui/utils/date.js';

export default helper(function utcOffsetHelper([ date ]) {
  return date instanceof Date ? utcOffset(date) : '';
});
